export const FLEET = {
  SHIP_COUNT: 12,
  TRAIL_MAX: 44,
  TRAIL_EVERY: 4,
  LANE_SAMPLES: 36,
  PUSH_RADIUS: 240,
  PUSH_FORCE: 0.4,
  SPRING: 0.01,
  DAMP: 0.93,
  DRIFT_LIMIT: 170,
  MIN_SPEED: 0.00042,
  MAX_SPEED: 0.00098,
};

const TAU = Math.PI * 2;

function between(rng, min, max) { return min + rng() * (max - min); }
function clamp(value, min, max) { return Math.min(Math.max(value, min), max); }

// rute dibangkitkan sekali dalam satuan 0..1, jadi resize gak perlu bikin ulang
export function buildRoute(index, count, rng) {
  const forward = index % 2 === 0;
  // jalur berhenti di 0.74 biar armadanya gak tenggelam di balik gelombang
  const lane = 0.06 + ((index + 0.5) / count) * 0.66;
  const y0 = clamp(lane + between(rng, -0.06, 0.06), 0.05, 0.74);
  const y1 = clamp(y0 + between(rng, -0.24, 0.24), 0.05, 0.74);
  // ujung rute di luar layar biar lompatan saat mengulang gak kelihatan
  const x0 = forward ? -0.12 : 1.12;
  const dx = forward ? 1.24 : -1.24;
  const dy = y1 - y0;
  const span = Math.sqrt(dx * dx + dy * dy) || 1;
  return {
    x0,
    y0,
    dx,
    dy,
    normalX: -dy / span,
    normalY: dx / span,
    amplitude: between(rng, 0.05, 0.14),
    waves: 1 + Math.round(rng()),
    phase: rng() * TAU,
  };
}

// amplop sinus bikin lengkungnya mengendur di kedua ujung rute
export function routePoint(route, t) {
  const swing = Math.sin(t * TAU * route.waves + route.phase)
    * route.amplitude * Math.sin(Math.PI * t);
  return {
    x: route.x0 + route.dx * t + route.normalX * swing,
    y: route.y0 + route.dy * t + route.normalY * swing,
  };
}

// pegas meluruh: simpangannya melengkung balik ke rute, bukan posisinya ditarik paksa
export function stepShip(ship, bgMotion) {
  let velX = ship.velX - ship.offsetX * FLEET.SPRING;
  let velY = ship.velY - ship.offsetY * FLEET.SPRING;
  velX *= FLEET.DAMP;
  velY *= FLEET.DAMP;
  let offsetX = ship.offsetX + velX * bgMotion;
  let offsetY = ship.offsetY + velY * bgMotion;
  const drift = Math.sqrt(offsetX * offsetX + offsetY * offsetY);
  if (drift > FLEET.DRIFT_LIMIT) {
    offsetX = (offsetX / drift) * FLEET.DRIFT_LIMIT;
    offsetY = (offsetY / drift) * FLEET.DRIFT_LIMIT;
  }
  return {
    ...ship, offsetX, offsetY, velX, velY,
  };
}

export function linkAlpha(distance, linkDistance) {
  if (!(linkDistance > 0) || distance >= linkDistance) return 0;
  return 1 - distance / linkDistance;
}

export function createFleet(rng) {
  const ships = [];
  for (let i = 0; i < FLEET.SHIP_COUNT; i += 1) {
    ships.push({
      route: buildRoute(i, FLEET.SHIP_COUNT, rng),
      t: ((i / FLEET.SHIP_COUNT) + rng() * 0.08) % 1,
      speed: between(rng, FLEET.MIN_SPEED, FLEET.MAX_SPEED),
      offsetX: 0,
      offsetY: 0,
      velX: 0,
      velY: 0,
      trail: [],
    });
  }
  return ships;
}
